import Vue from "vue";
import { mapGetters } from "vuex";
import store from "@continente/vue/components/store";
import { bookDeliverySlot } from "../../../checkout/checkoutUtil";
import { reInitVisualSteps } from "./../../../checkout/visualSteps";
import { waitForEl } from "./../../../utilities/globalUtilities";
import { parents } from "./../../../utilities/selectorHelper";
import { SCHEDULE_ITEM_HEIGHT, SCHEDULE_COLUMNS_NUMBER, SCHEDULE_COLUMNS_NUMBER_TABLET } from "../../../utilities/constants";
import { isNewAddressInputSelected, openNewAddressModal, enableNextSlideValidation } from "../../../checkout/shippingCTUtils";

/**
 * Delivery Schedule Date Item Component
 */
const DeliveryScheduleDateItem = Vue.component("delivery-schedule-date-item", {
    template: `
        <div :class="['delivery-schedule-date-item align-content-center text-center d-block d-md-inline-block', isNonScheduled ? 'pwc-form-radio is-non-schedule col-12 single-slot' : '', !isNonScheduled && deliverySlotsLength < 2 ? 'col-12 col-sm-6 col-md-4 single-slot' : '']">
            <input
                @click="updateShippingInformation"
                type="radio"
                aria-checked="false"
                title
                :name="'date' + shippingId"
                :value="value"
                v-model="dateitem"
                :id="'date-item-' + shippingId + '-' + index"
                :data-shipment-id="shippingId"
                :data-index="index"
                :data-weekday-short="isNonScheduled ? '' : deliverySlot.slotDateDayNameShort"
                :data-day="isNonScheduled ? '' : deliverySlot.slotDateDay"
                :data-month="isNonScheduled ? '' : deliverySlot.slotDateMonth"
                :data-intervals-number="isNonScheduled ? 0 : deliverySlot.slotDetails.length"
                :data-price="isNonScheduled ? deliverySlot.formattedShippingCost : ''"
                :data-interval="isNonScheduled ? (value + ' ' + nonScheduledInterval) : ''"
                :data-shipping-slot-scheduler-id="isNonScheduled ? deliverySlot.shippingSlotSchedulerId : ''"
                :data-shipping-slot-list-id="isNonScheduled ? deliverySlot.shippingListId : ''"
                :data-shipping-slot-operator-id="isNonScheduled ? deliverySlot.shippingOperatorId : ''"
            />
            <label
                class="row delivery-schedule-date-item-label align-items-center"
                :for="'date-item-' + shippingId + '-' + index"
            >
                <span class="col-12 pwc-subtitle no-padding week-day" v-if="!isNonScheduled">{{deliverySlot.slotDateDay}}</span>
                <span class="col-12 pwc-sub-body no-padding day-month" v-if="!isNonScheduled">{{deliverySlot.slotDateDayNameShort}}</span>
                <span class="interval-item-range text-left d-flex flex-column flex-sm-row mr-1" v-if="isNonScheduled">
                    <span>{{ value }}</span>
                    <span class="non-scheduled-interval-value">{{ nonScheduledInterval }}</span>
                </span>
                <span :class="['pwc-tile--price-primary align-content-center', deliverySlot.isFreeDelivery ? 'pwc-strike-through' : '']" v-if="isNonScheduled">{{ deliverySlot.formattedShippingCost }}</span>
            </label>
            <span class="checkmark" v-if="isNonScheduled">
                <span v-html="checkmarkIcon" v-show="checkmarkIcon" />
            </span>
        </div>
    `,
    methods: {
        // Update the store shipping information (active index) when a date radio is checked
        async updateShippingInformation(e) {
            const target = e.target;
            const shipmentID = target.getAttribute("data-shipment-id");
            const currentShippingStatus = this.getShipmentData(shipmentID);
            const targetIndex = target.getAttribute("data-index");
            const targetWeekdayShort = target.getAttribute("data-weekday-short");
            const targetDay = target.getAttribute("data-day");
            const targetMonth = target.getAttribute("data-month");
            const deliveryScheduleDate = parents(target, ".delivery-schedule-date")[0];

            if (deliveryScheduleDate.classList.contains("non-scheduled-delivery")) {
                const targetPrice = target.getAttribute("data-price");
                const targetInterval = target.getAttribute("data-interval");
                const shippingSlotSchedulerId = target.getAttribute("data-shipping-slot-scheduler-id");
                const shippingListId = target.getAttribute("data-shipping-slot-list-id");
                const shippingSlotOperatorId = target.getAttribute("data-shipping-slot-operator-id");

                // ajax call to reserve selected time slot
                const response = await bookDeliverySlot(shipmentID, shippingSlotSchedulerId, shippingSlotOperatorId, shippingListId);
                if (!response) { return; }

                currentShippingStatus.chosenPrice = targetPrice;
                currentShippingStatus.chosenInterval = targetInterval;

                store.commit("setShipmentData", currentShippingStatus);

                // Remove the `selected` class from all the inputs
                const currentShipmentContainer = document.querySelectorAll(`.delivery-schedule-date input[data-shipment-id="${shipmentID}"]`);
                currentShipmentContainer.forEach(input => input.parentElement.classList.remove("selected-non-scheduled"));
                // Add the `selected` class to the checked input
                target.parentElement.classList.add("selected-non-scheduled");

                const shippingsCount = $(".js-shipment-step")?.length;
                if (shippingsCount >= 2) {
                    enableNextSlideValidation();
                }
            } else {
                currentShippingStatus.activeIndex = targetIndex;
                currentShippingStatus.chosenWeekdayShort = targetWeekdayShort;
                currentShippingStatus.chosenDay = targetDay;
                currentShippingStatus.chosenMonth = targetMonth;

                // Remove the `selected` class from all the inputs
                const currentShipmentContainer = document.querySelectorAll(`.delivery-schedule-date input[data-shipment-id="${shipmentID}"]`);
                currentShipmentContainer.forEach(input => {
                    input.parentElement.classList.remove("selected");
                    input.setAttribute("aria-checked", "false");
                });

                // Add the `selected` class to the checked input
                target.parentElement.classList.add("selected");
                target.setAttribute("aria-checked", target.checked);

                var slotSelected = false;
                const intervalItemList = document.querySelectorAll(`.delivery-schedule-interval-list input[data-shipment-id="${shipmentID}"]`);
                intervalItemList.forEach(input => {
                    if (input.getAttribute("aria-checked") === "true") {
                        slotSelected = input;
                    }
                });

                if (slotSelected) {
                    const shippingSlotSchedulerId = slotSelected.getAttribute("data-shipping-slot-scheduler-id");
                    const shippingListId = slotSelected.getAttribute("data-shipping-slot-list-id");
                    const shippingSlotOperatorId = slotSelected.getAttribute("data-shipping-slot-operator-id");
                    const response = await bookDeliverySlot(shipmentID, shippingSlotSchedulerId, shippingSlotOperatorId, shippingListId, true);
                    if (!response) { return; }

                    currentShippingStatus.chosenPrice = "-";
                    currentShippingStatus.originalPrice = "";
                }

                //in the first execution of this code, we don't want this part to run and select the first slot available for that day
                //so this.isInitialized is only true after the first render and allows the previous slot selected for the day to be selected
                if (this.autoSelectSlot && this.isInitialized) {
                    waitForEl(`.shipping-delivery-slot[data-shipment-id="${shipmentID}"] #scheduleList_${targetIndex}`, function () {
                        const newIntervalItemList = document.querySelector(`.delivery-schedule-interval-list input[data-shipment-id="${shipmentID}"]`);
                        newIntervalItemList?.click();
                    });
                }
                
                store.commit("setShipmentData", currentShippingStatus);
                
                const shippingsCount = $(".js-shipment-step")?.length;
                if (shippingsCount >= 2) {
                    enableNextSlideValidation();
                }

                if (!window.mqRespond.status.mobile) {
                    this.updateIntervalsPerColumn(target);
                }
            }
        },
        updateIntervalsPerColumn(target) {
            const list = parents(target, ".delivery-schedule-wrapper")[0].querySelector(".delivery-schedule-interval-list");
            const itemsNumber = target.getAttribute("data-intervals-number");
            const numberOfColumns = window.mqRespond.status.tablet ? SCHEDULE_COLUMNS_NUMBER_TABLET : SCHEDULE_COLUMNS_NUMBER;
            const itemsPerColumn = Math.ceil(itemsNumber / numberOfColumns);
            list.style.maxHeight = `${itemsPerColumn * (SCHEDULE_ITEM_HEIGHT + 14)}px`; //last parameter accounting for padding
        },
        alignIntervalsPerColumn() {
            document.querySelectorAll(".delivery-schedule-interval-list").forEach(list => {
                const itemsNumber = list.querySelectorAll("li").length;
                const numberOfColumns = window.mqRespond.status.tablet ? SCHEDULE_COLUMNS_NUMBER_TABLET : SCHEDULE_COLUMNS_NUMBER;
                const itemsPerColumn = Math.ceil(itemsNumber / numberOfColumns);
                list.style.maxHeight = `${itemsPerColumn * (SCHEDULE_ITEM_HEIGHT + 14)}px`; //last parameter accounting for padding (7px padding top and bottom totaling 14px)
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.isInitialized = true;
        });
        if (!window.mqRespond.status.mobile) {
            this.alignIntervalsPerColumn();
        }
    },
    computed: {
        ...mapGetters([
            "getShipmentData"
        ])
    },
    data() {
        return {
            dateitem: "",
        };
    },
    props: ["deliverySlot", "index", "nonScheduledInterval", "value", "shippingId", "isNonScheduled", "deliverySlotsLength", "checkmarkIcon", "autoSelectSlot"]
});

/**
 * Delivery Schedule Interval List Component
 */
/**
 * //TODO CDSSO-2961 extra attribute PASS for each delivery range time....
 * */
const DeliveryScheduleIntervalList = Vue.component("delivery-schedule-interval-list", {
    template: `
        <div v-if="deliverySlots && deliverySlots[getActiveIndex]">
            <ul :id="'scheduleList_'+  getActiveIndex" :class="['row no-margin delivery-schedule-interval-list', deliverySlots[getActiveIndex].slotDetails && deliverySlots[getActiveIndex].slotDetails.length > 3 ? 'toggle-list' : '']">
                <delivery-schedule-interval-item
                    v-for="(slotDetail, index) in deliverySlots[getActiveIndex].slotDetails"
                    :value="slotDetail.formattedStart + ' - ' + slotDetail.formattedEnd"
                    :slot-detail="slotDetail"
                    :shipping-id="shippingId"
                    :index="index"
                    :key="index + '_' + slotDetail.shippingSlotSchedulerId"
                    :checkmarkIcon="checkmarkIcon"
                />
            </ul>
            <div
                v-if="deliverySlots[getActiveIndex].slotDetails && deliverySlots[getActiveIndex].slotDetails.length > 3"
                @click.prevent="toggleList(getActiveIndex)"
                data-target="scheduleList"
                class="row no-margin d-sm-none js-toggle-list toggle-interval-list"
            >
                <a v-if="this.toggledText"><span class="see-more-button">{{resources.moreItems}}</span><span class="see-more-slots-icon" v-html="arrowUpDown" v-show="arrowUpDown"/></span></a>
                <a v-else><span class="see-more-button">{{resources.lessItems}}</span><span class="see-more-slots-icon rotate-svg-upside-down" v-html="arrowUpDown" v-show="arrowUpDown" /></span></a>
            </div>
        </div>
    `,
    computed: {
        ...mapGetters([
            "getShipmentData"
        ]),
        // Gets the current active index for the shipment information, from the vuex store
        // and sets it in the loop that is done in order to re-render the component
        getActiveIndex: function () {
            const currentShippingID = this.shippingId;
            const currentShipment = this.getShipmentData(currentShippingID);

            return currentShipment.activeIndex;
        }
    },
    methods: {
        toggleList(scheduleListId) {
            const listId = "scheduleList_"+scheduleListId;
            const list = document.getElementById(listId);
            if (list) {
                const hasClass = list.classList.contains("toggle-list");
                list.classList.toggle("toggle-list", !list.classList.contains("toggle-list"));
                this.toggledText = !hasClass;
                reInitVisualSteps();
            }
        }
    },
    data() {
        return {
            toggledText: true
        };
    },
    props: ["deliverySlots", "shippingId", "resources", "checkmarkIcon", "arrowUpDown"]
});

/**
 * Delivery Schedule Interval Item Component
 */
const DeliveryScheduleIntervalItem = Vue.component("delivery-schedule-interval-item", {
    template: `
        <li class="col-12 col-sm-6 col-md-4 delivery-schedule-interval-item">
            <span class="interval-item-wrapper pwc-form-radio align-items-center">
                <input
                    class="pwc-form-check-input"
                    @click="updateShippingInformation"
                    type="radio"
                    aria-checked="false"
                    title
                    :id="'interval-item-' + shippingId + '-' + index"
                    :name="'interval-' + shippingId"
                    v-model="intervalitem"
                    :value="value"
                    :data-price="slotDetail.formattedShippingCost"
                    :data-interval="slotDetail.formattedStart + ' - ' + slotDetail.formattedEnd"
                    :data-shipment-id="shippingId"
                    :data-shipping-slot-scheduler-id="slotDetail.shippingSlotSchedulerId"
                    :data-shipping-slot-list-id="slotDetail.shippingListId"
                    :data-shipping-slot-operator-id="slotDetail.shippingOperatorId"
                />
                <label
                    class="pwc-form-check-label h-100"
                    :for="'interval-item-' + shippingId + '-' + index"
                >
                    <span class="interval-item-range">{{ slotDetail.formattedStart }} - {{ slotDetail.formattedEnd }}</span>
                    <span :class="['pwc-tile--price-primary interval-item-price', slotDetail.isFreeDelivery || isDiscountOrFree ? 'pwc-strike-through' : '']">{{ slotDetail.formattedShippingCost }}</span>
                </label>
                <span class="checkmark" v-html="checkmarkIcon" v-show="checkmarkIcon"></span>
            </span>
        </li>
    `,
    methods: {
        // Update the store shipping information (active index) when a date radio is checked
        async updateShippingInformation(e) {
            const target = e.target;
            const shipmentID = target.getAttribute("data-shipment-id");
            const currentShippingStatus = this.getShipmentData(shipmentID);
            const targetPrice = target.getAttribute("data-price");
            const targetInterval = target.getAttribute("data-interval");
            const shippingSlotSchedulerId = target.getAttribute("data-shipping-slot-scheduler-id");
            const shippingListId = target.getAttribute("data-shipping-slot-list-id");
            const shippingSlotOperatorId = target.getAttribute("data-shipping-slot-operator-id");

            const relatedStep = target.closest(".step--wrapper");
            const relatedShipment = relatedStep.previousElementSibling;

            if (relatedShipment !== null) {
                const selectedAddressRadio = relatedShipment.querySelector(".pwc-form-check-input:checked");
                const isPrimaryShipment = relatedShipment.getAttribute("data-is-primary") === "true";

                if (isPrimaryShipment && isNewAddressInputSelected($(selectedAddressRadio))) {
                    e.preventDefault();
                    openNewAddressModal($(selectedAddressRadio));
                    return;
                }
            }

            // ajax call to reserve selected time slot
            const response = await bookDeliverySlot(shipmentID, shippingSlotSchedulerId, shippingSlotOperatorId, shippingListId);
            if (!response) { return; }

            currentShippingStatus.chosenPrice = targetPrice;
            currentShippingStatus.chosenInterval = targetInterval;
            currentShippingStatus.chosenSlotId = shippingSlotSchedulerId;

            store.commit("setShipmentData", currentShippingStatus);

            // Remove the `selected` class from all the inputs
            const currentShipmentContainer = document.querySelectorAll(`.delivery-schedule-interval-list input[data-shipment-id="${shipmentID}"]`);
            currentShipmentContainer.forEach(input => {
                input.parentElement.classList.remove("selected");
                input.setAttribute("aria-checked", "false");
            });

            // Add the `selected` class to the checked input
            target.parentElement.classList.add("selected");
            target.setAttribute("aria-checked", target.checked);


            /* This code is commented out and is not necessary at this phase because we
            currently have a bug where some products might not have delivery slots available.
            Therefore, addresses must be shown to the user so they can pick another address or choose Click&Go. */
            // Close all the addresses sections that are open and show the summary of them
            /* [...document.querySelectorAll(".step-type--address")].forEach(addressStep => {
                const selectedAddressRadioCurrentStep = addressStep?.querySelector(".pwc-form-check-input:checked");
                if ((selectedAddressRadioCurrentStep && addressStep.getAttribute("data-is-primary") === "true" && isNewAddressInputSelected($(selectedAddressRadioCurrentStep))) || !selectedAddressRadioCurrentStep) { return; }
                disableAndNextStep(addressStep, true, true);
            }); */

            // Reset Cartao Continente and Cartao Da summary values
            let checkoutOrderSummaryInfo = store.getters.getOrderSummaryInfo();

            checkoutOrderSummaryInfo.loyaltyBalance = null;
            checkoutOrderSummaryInfo.cartaodaBalance = null;

            store.commit("setOrderSummaryInfo", checkoutOrderSummaryInfo);

            const shippingsCount = $(".js-shipment-step")?.length;
            if (shippingsCount >= 2) {
                enableNextSlideValidation();
            }
        },
    },
    computed: {
        ...mapGetters(["getShipmentData"]),
        isDiscountOrFree() {
            const { shippingId, slotDetail } = this;
            const currentShipment = this.getShipmentData(shippingId);

            if (!currentShipment) { return slotDetail?.isFreeDelivery || false; }

            const { originalPrice, discountPrice, shipmentDeliverySlots: deliverySlots } = currentShipment;
            const isShippingDiscount = currentShipment.chosenSlotId == slotDetail.shippingSlotSchedulerId && originalPrice != "" && discountPrice != originalPrice;

            return slotDetail?.isFreeDelivery || deliverySlots?.groupedDeliverySlots?.[0]?.isFreeDelivery || isShippingDiscount;
        }
    },
    data() {
        return {
            intervalitem: ""
        };
    },
    props: ["slotDetail", "index", "value", "shippingId", "checkmarkIcon"]
});

/**
 * Delivery Schedule Interval Item Component
 */
const DeliveryScheduleSummary = Vue.component("delivery-schedule-summary", {
    template: `
        <div v-if="setSummaryInfo" class="step-body--resume js-step-body-resume delivery-schedule-summary d-none">
            <div class="col-12 no-padding delivery-schedule-summary-date">
                {{ setSummaryInfo.chosenWeekdayShort }}, {{ setSummaryInfo.chosenDay }} {{ setSummaryInfo.chosenMonth }} - {{ setSummaryInfo.chosenInterval }}
            </div>
            <div class="col-12 no-padding pwc-subtitle delivery-schedule-summary-price">
                <span v-if="!setSummaryInfo.isFreeDelivery && (parseFloat(setSummaryInfo.discountPrice.substring(1).replace(',', '.')) !== 0 || setSummaryInfo.discountPrice == setSummaryInfo.chosenPrice)" class="shipping-adjusted-price d-inline-block"> {{ setSummaryInfo.isShippingDiscount ? setSummaryInfo.discountPrice : setSummaryInfo.chosenPrice}} </span>
                <span v-if="setSummaryInfo.isFreeDelivery || setSummaryInfo.isShippingDiscount" class="d-inline-block pwc-strike-through">{{ setSummaryInfo.chosenPrice }} </span>
                <span v-html="entregaZeroIcon" v-show="setSummaryInfo.isFreeDelivery" />
            </div>
        </div>
    `,
    methods: {},
    computed: {
        ...mapGetters(["getShipmentData"]),
        setSummaryInfo() {
            const currentShippingID = this.shippingId;
            let isFreeDelivery = false;
            const currentShipment = this.getShipmentData(currentShippingID);

            if (!currentShipment) { return; }

            const deliverySlots = currentShipment.shipmentDeliverySlots;
            const isShippingDiscount = currentShipment.originalPrice != "" && currentShipment.discountPrice != currentShipment.originalPrice;

            if (deliverySlots && deliverySlots.groupedDeliverySlots) {
                if (!deliverySlots.groupedDeliverySlots[0] || !deliverySlots.groupedDeliverySlots[0].slotDetails || !deliverySlots.groupedDeliverySlots[0].slotDetails[0]) { return; }

                isFreeDelivery = deliverySlots.groupedDeliverySlots[0].slotDetails[0].isFreeDelivery;
            }

            return {
                chosenWeekdayShort: currentShipment.chosenWeekdayShort,
                chosenDay: currentShipment.chosenDay,
                chosenMonth: currentShipment.chosenMonth,
                chosenInterval: currentShipment.chosenInterval,
                chosenPrice: currentShipment.chosenPrice,
                discountPrice: currentShipment.discountPrice,
                originalPrice: currentShipment.originalPrice,
                isFreeDelivery: isFreeDelivery,
                isShippingDiscount: isShippingDiscount
            };
        }
    },
    data() {
        return {};
    },
    props: ["shippingId", "entregaZeroIcon"]
});

/**
 * Delivery Schedule Interval Item Component
 */
const DeliveryNonScheduledSummary = Vue.component("delivery-non-scheduled-summary", {
    template: `
        <div class="step-body--resume js-step-body-resume delivery-schedule-summary d-none">
            <div class="col-12 no-padding delivery-schedule-summary-date d-flex flex-column flex-sm-row">
                <span class="slot-details-working-days">{{ shipmentDeliverySlots.slotDetailsDescription }} {{ shipmentDeliverySlots.slotDetailsWorkingDays }}</span>
                <span class="non-schduled-summary-separator d-none d-sm-block">|</span>
                <span>{{ setSummaryInfo.chosenInterval }}</span>
            </div>
            <div class="col-12 no-padding pwc-subtitle delivery-schedule-summary-price">
                <span v-if="!setSummaryInfo.isFreeDelivery && (parseFloat(setSummaryInfo.discountPrice.substring(1).replace(',', '.')) !== 0 || setSummaryInfo.discountPrice == setSummaryInfo.chosenPrice)" class="shipping-adjusted-price d-inline-block"> {{ setSummaryInfo.isShippingDiscount ? setSummaryInfo.discountPrice : setSummaryInfo.chosenPrice}} </span>
                <span v-if="setSummaryInfo.isFreeDelivery || setSummaryInfo.isShippingDiscount" class="d-inline-block pwc-strike-through">{{ setSummaryInfo.chosenPrice }} </span>
                <span v-html="entregaZeroIcon" v-show="setSummaryInfo.isFreeDelivery" />
            </div>
        </div>
    `,
    methods: {},
    computed: {
        ...mapGetters(["getShipmentData"]),
        setSummaryInfo() {
            const currentShippingID = this.shippingId;
            let isFreeDelivery = false;
            const currentShipment = this.getShipmentData(currentShippingID);
            const deliverySlots = currentShipment.shipmentDeliverySlots;

            if (!currentShipment) { return; }

            const isShippingDiscount = currentShipment.originalPrice != "" && currentShipment.discountPrice != currentShipment.originalPrice;

            if (deliverySlots.groupedDeliverySlots) {
                if (!deliverySlots.groupedDeliverySlots[0]) { return; }

                isFreeDelivery = deliverySlots.groupedDeliverySlots[0].isFreeDelivery;
            }

            return {
                chosenInterval: currentShipment.chosenInterval,
                chosenPrice: currentShipment.chosenPrice,
                isFreeDelivery: isFreeDelivery,
                isShippingDiscount: isShippingDiscount,
                discountPrice: currentShipment.discountPrice,
            };
        }
    },
    data() {
        return {};
    },
    props: ["shipmentDeliverySlots", "shippingId", "entregaZeroIcon"]
});

export {
    DeliveryScheduleIntervalList,
    DeliveryScheduleDateItem,
    DeliveryScheduleIntervalItem,
    DeliveryScheduleSummary,
    DeliveryNonScheduledSummary
};
